import { colors } from 'common/ui/theme/default';

export const hoverColors = {
  [colors.colorPicker.defaultColor]: '#4C9900',
  [colors.colorPicker.freshGreen]: '#199145',
  [colors.colorPicker.emerald]: '#0C875E',
  [colors.colorPicker.teal]: '#0E8578',
  [colors.colorPicker.brightCyan]: '#058AA1',
  [colors.colorPicker.skyBlue]: '#2C96C4',
  [colors.colorPicker.clearSky]: '#2C96C4',
  [colors.colorPicker.deepSky]: '#016294',
  [colors.colorPicker.blue]: '#2E66C2',
  [colors.colorPicker.softBlue]: '#4C83C7',
  [colors.colorPicker.indigo]: '#1D4DB8',
  [colors.colorPicker.softIndigo]: '#4F51BF',
  [colors.colorPicker.violet]: '#6E48C2',
  [colors.colorPicker.fuchsia]: '#8644C4',
  [colors.colorPicker.lavender]: '#996AC9',
  [colors.colorPicker.deepPink]: '#A81E5B',
  [colors.colorPicker.pink]: '#BA3979',
  [colors.colorPicker.rose]: '#C75A69',
  [colors.colorPicker.forestGreen]: '#0B331A',
  [colors.colorPicker.slate]: '#0B331A',
  [colors.colorPicker.red]: '#BD3636',
  [colors.colorPicker.orange]: '#C75C12',
  [colors.colorPicker.amber]: '#C77430',
  [colors.colorPicker.goldenrod]: '#C29611',
  [colors.colorPicker.darkAmber]: '#A65B05',
};
